import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(registerButtonHandler),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(deregisterButton),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(registeredButtonHandler),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(animatingButtonSaga);

import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import { delay, takeEvery, race, all, put, call, take } from 'redux-saga/effects';
import * as _ from "../../../../util/lodash";
import { Actions } from "./animating-button-duck"; // Keep an internal list of registered buttons keyed by the startAction for easier lookup

var registeredButtons = {};

function registerButtonHandler(_ref) {
  var payload, id, actions;
  return _regeneratorRuntime.wrap(function registerButtonHandler$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = _ref.payload;
          id = payload.id;
          actions = _.isArray(payload.actions) ? payload.actions : [payload.actions];

          _forEachInstanceProperty(_).call(_, actions, function (_ref2) {
            var start = _ref2.start,
                success = _ref2.success,
                failure = _ref2.failure;
            var actionType = getActionType(start);
            registeredButtons[actionType] = {
              id: id,
              success: success,
              failure: failure
            };
          });

        case 4:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function deregisterButton(_ref3) {
  var payload;
  return _regeneratorRuntime.wrap(function deregisterButton$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _ref3.payload;
          // There can be multiple registrations for a single id
          registeredButtons = _.omitBy(registeredButtons, function (action) {
            return action.id === payload.id;
          });

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

function registeredButtonHandler(_ref4) {
  var type, registeredButton, _yield$all, success;

  return _regeneratorRuntime.wrap(function registeredButtonHandler$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          type = _ref4.type;
          // This is the beginning of a new animation flow. Retrieve the animation description
          registeredButton = registeredButtons[type]; // Start the animation

          _context3.next = 4;
          return put(Actions.startAnimation(registeredButton.id));

        case 4:
          _context3.next = 6;
          return all([race({
            success: take(getActionType(registeredButton.success)),
            failure: take(getActionType(registeredButton.failure))
          }), delay(250)]);

        case 6:
          _yield$all = _context3.sent;
          success = _yield$all[0].success;

          if (!success) {
            _context3.next = 13;
            break;
          }

          _context3.next = 11;
          return put(Actions.success(registeredButton.id));

        case 11:
          _context3.next = 15;
          break;

        case 13:
          _context3.next = 15;
          return put(Actions.failure(registeredButton.id));

        case 15:
          _context3.next = 17;
          return delay(500);

        case 17:
          _context3.next = 19;
          return put(Actions.finishAnimation(registeredButton.id));

        case 19:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}

function isRegisteredButton(_ref5) {
  var type = _ref5.type;
  // only listen on actions that have been registered, otherwise, ignore
  return !_.isUndefined(registeredButtons[type]);
}

function getActionType(action) {
  if (!!action.getType && typeof action.getType === 'function') return action.getType();
  if (typeof action === 'string') return action;
  return '';
}

export default function animatingButtonSaga() {
  return _regeneratorRuntime.wrap(function animatingButtonSaga$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return all([takeEvery(Actions.registerButton.getType(), registerButtonHandler), takeEvery(isRegisteredButton, registeredButtonHandler), takeEvery(Actions.deregisterButton.getType(), deregisterButton)]);

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}
//# sourceMappingURL=animating-button-sagas.js.map